// Initialize lazy image fade-in effect
function initLazyImages() {
  const images = document.querySelectorAll('.product-preview-image img.lazy-fade:not(.loaded)');
  images.forEach(img => {
    if (img.complete && img.naturalHeight !== 0) {
      // Image already loaded
      img.classList.add('loaded');
    } else {
      // Wait for image to load
      img.addEventListener('load', function() {
        img.classList.add('loaded');
      }, { once: true });

      // Handle error case - show image even if load fails
      img.addEventListener('error', function() {
        img.classList.add('loaded');
      }, { once: true });
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLazyImages);
} else {
  // DOM already loaded
  initLazyImages();
}

// Make function globally available for infinite scroll
window.initLazyImages = initLazyImages;
